import {createStyles, makeStyles, Theme} from '@material-ui/core';
import {LIGHT_GRAY, GRAY} from '../../../const/colors';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            margin:13,
            height:'336px',
            width: '408px',
            border: `1px solid ${LIGHT_GRAY}`,
            borderRadius: '3px',
            backgroundColor: 'transparent',
            padding: '24px',
            display: 'flex',
            flexDirection: 'column',
        },
        title: {
            marginTop:16,
            fontSize: '20px',
            fontWeight: 'bold',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            '-webkit-line-clamp': 3,
            '-webkit-box-orient': 'vertical',
            textAlign:'left',
            height:60
        },
        link:{
            color: theme.palette.secondary.main,
            cursor: 'pointer',
            marginTop: 16,
        },
        multiLineContentEllipsis: {
            marginTop:16,
            fontSize: '1rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            '-webkit-line-clamp': 5,
            '-webkit-box-orient': 'vertical',
        },
    }),
);

export default useStyles;
